import { DsButtonVariants, DsTooltipPosition, Icons } from '@levelaccess/design-system';
import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { BaseCellComponent, ICellConfig } from '../base-cell/base-cell.component';
import { ITooltipCellConfig, TooltipCellComponent } from '../tooltip-cell/tooltip-cell.component';

export interface ITooltipWrapperConfig<Reference extends ICellConfig> extends ICellConfig {
  reference: {
    type: any;
    config: Reference;
  };
  tooltip: ITooltipCellConfig;
}

@Component({
  selector: 'table-cell-tooltip-wrapper',
  styleUrls: ['../base-cell/base-cell.component.scss'],

  template: `
    <div class="d-flex" #tooltipWrapperRef>
      <dcl-wrapper [type]="config.reference.type" [config]="config.reference.config"></dcl-wrapper>
      <dcl-wrapper [type]="ToolTipCellComponent" [config]="config.tooltip"></dcl-wrapper>
    </div>
  `,
})
export class TooltipWrapperCellComponent<Reference extends ICellConfig> extends BaseCellComponent {
  @ViewChild('tooltipWrapperRef', { read: ElementRef })
  public element: ElementRef<HTMLElement>;
  @Input() public config: ITooltipWrapperConfig<Reference>;

  protected readonly DsTooltipPosition: typeof DsTooltipPosition = DsTooltipPosition;
  protected readonly DsButtonVariants: typeof DsButtonVariants = DsButtonVariants;
  protected readonly Icons: typeof Icons = Icons;
  protected readonly ToolTipCellComponent: typeof TooltipCellComponent = TooltipCellComponent;
}
